'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { ChartBarLineIcon } from '@/components/ui/icon/glyphs';
import { Link } from '@/i18n/navigation';
export function PositionsEmpty(t0) {
  const $ = _c(19);
  const {
    tab
  } = t0;
  const t = useTranslations("profile.next.empty.positions");
  if (tab === "closed") {
    let t1;
    if ($[0] !== t) {
      t1 = t("closed_title");
      $[0] = t;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t) {
      t2 = t("closed_body");
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = <EmptyState icon={ChartBarLineIcon} title={t1} description={t2} />;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t1;
  if ($[7] !== t) {
    t1 = t("title");
    $[7] = t;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== t) {
    t2 = t("body");
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t) {
    t3 = t("cta");
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <AnimatedButton asChild={true} variant="secondary"><Link href="/markets">{t3}</Link></AnimatedButton>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t4) {
    t5 = <EmptyState icon={ChartBarLineIcon} title={t1} description={t2} action={t4} />;
    $[15] = t1;
    $[16] = t2;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}